
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/truck-drivers-news",
      function () {
        return require("private-next-pages/truck-drivers-news/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/truck-drivers-news"])
      });
    }
  